import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 1000 * 60,
            refetchOnWindowFocus: false,
        },
    },
})

export function clearPrivateQueryCache(): void {
    queryClient.clear()
}
